import { formDeleteApplication, formatDateTime, payloadFVGDeleteApplication } from '../helpers';

import {
    ORGANISATION_DETAILS,
    SECT_ADDRESS,
    SECT_APPLICANT,
    TITLE_DETAILS
} from 'common/application.const/VideoGames/declarationOfInteractiveSoftware';

import { DetailsType, FormData } from 'types/application';
import { requestAttachmentFVG } from 'store/api/application.api';

type Props = {
    myInfoContent: any;
    uen?: string;
    id?: string;
    userRole?: string;
};

export const autoFillData = ({ myInfoContent, uen, id, userRole }: Props) => {
    const general_selected = userRole === 'corppass' ? 'generalCompany' : 'generalApplicant';
    const person = myInfoContent?.corppass || myInfoContent || {};
    const entity = myInfoContent?.['basic-profile'] || {};
    const corpUser = person?.['corppass-user'] || {};
    const address = myInfoContent?.address || person?.regadd || {};

    const isFin = ['F', 'G', 'M'].some((pre: string) => person?.uinfin?.value?.startsWith(pre));

    let idType;

    if (isFin) idType = 'IDT2';

    if (person?.nationality?.code && !isFin) {
        idType = person.nationality.code === 'SG' ? 'IDT' : '';
    }

    let salutation = '';
    if (person.sex) {
        salutation = person.sex?.code === 'M' ? 'Mr.' : 'Ms.';
    }

    let corpUserID = corpUser['id-type']?.desc;

    if (corpUserID === 'NRIC') corpUserID = 'IDT';
    if (corpUserID === 'FIN') corpUserID = 'IDT2';

    const generalForm = {
        id: general_selected,
        formID: `appDetails-${general_selected}`,
        hasError: true,
        values: {
            [`${SECT_APPLICANT}-id-type`]: corpUserID || idType,
            [`${SECT_APPLICANT}-idno`]: corpUser['id-no']?.value || person?.uinfin?.value,
            [`${SECT_APPLICANT}-salutaion`]: salutation,
            [`${SECT_APPLICANT}-name`]: corpUser.name?.value || person?.name?.value,
            [`${SECT_APPLICANT}-mobile-no-country-code`]: person?.mobileno?.areacode?.value || '65',
            [`${SECT_APPLICANT}-mobile-no-main`]: person?.mobile?.value || person?.mobileno?.nbr?.value,
            [`${SECT_APPLICANT}-email`]: person?.email?.value,
            // [`${SECT_APPLICANT}-nationality`]: person?.nationality?.code,

            [`${ORGANISATION_DETAILS}-organisation-uen-no`]: entity.uen?.value,
            [`${ORGANISATION_DETAILS}-organisation-name`]: entity['entity-name']?.value,

            [`${SECT_ADDRESS}-postal`]: address.postal?.value,
            [`${SECT_ADDRESS}-block-house`]: address.block?.value,
            [`${SECT_ADDRESS}-street`]: address.street?.value,
            [`${SECT_ADDRESS}-floor`]: address.floor?.value,
            [`${SECT_ADDRESS}-unit`]: address.unit?.value,
            [`${SECT_ADDRESS}-building`]: address.building?.value
        }
    };

    return generalForm;
};

export const formatRetrieve = async (
    _content: any,
    _caseTypeID: string,
    _action?: string,
    applicationForm?: string,
    userRole?: string,
    dropdownOpts?: any,
    newApplication?: boolean
) => {
    if (_action === 'application-delete') return formDeleteApplication;
    const general_selected = userRole === 'corppass' ? 'generalCompany' : 'generalApplicant';
    const applicantValues = _content.applicant || {};
    const companyValues = _content.company || {};
    const applicantContact = applicantValues.ContactPage || {};
    const companyContact = companyValues.ContactPage || {};
    // const applicantAddress =
    //     applicantValues.Address && applicantValues.Address.length > 0 ? applicantValues.Address[0]?.MailingAddress || {} : {};
    // const companyAddress = companyValues.Address && companyValues.Address.length > 0 ? companyValues.Address[0]?.MailingAddress || {} : {};
    const applicantAddress = applicantValues.MailingAddress || {};
    const companyAddress = companyValues.MailingAddress || {};

    let summary;
    let general;
    let title;
    let downloads = {};

    if (_action === 'download') {
        const uploadedFiles = (
            _caseTypeID
                ? await requestAttachmentFVG(_caseTypeID).then((res) =>
                      res.map((i: any) => ({
                          ...i,
                          pyCategory:
                              i.Type === 'Application' && i.pyCategory === 'Receipt'
                                  ? 'Payment Receipt'
                                  : i.Type === 'Application' && i.pyCategory === 'Invoice'
                                    ? 'Invoice'
                                    : i.Type === 'Appeal' && i.pyCategory === 'Receipt'
                                      ? 'Appeal Receipt'
                                      : i.Type === 'Appeal' && i.pyCategory === 'Invoice'
                                        ? 'Appeal Invoice'
                                        : i.pyCategory === 'SubmissionReceipt'
                                          ? 'Submission Receipt'
                                          : i.pyCategory === 'Notification'
                                            ? 'Notification'
                                            : i.pyCategory
                      }))
                  )
                : []
        ) as any[];

        let files = {};

        if (_content?.CustomerStatus === 'Rejected' || _content?.CustomerStatus === 'Withdrawn' || _content?.CustomerStatus === 'Voided') {
            files = uploadedFiles
                .filter((i) => i.pyCategory !== 'Certificate' && i.pyCategory !== 'Notification')
                .map((i) => {
                    return {
                        id: 'FVGFiles',
                        data: [i.fileName, i.pyCategory, 'Download'],
                        fileName: i.fileName,
                        pyCategory: i.pyCategory,
                        DownloadLink: i.DownloadLink
                    };
                });
        } else if (
            _content?.CustomerStatus === 'Submitted' ||
            _content?.CustomerStatus === 'Processing' ||
            _content?.CustomerStatus === 'Pending Payment'
        ) {
            files = uploadedFiles
                .filter((i) => i.pyCategory !== 'Certificate' && i.pyCategory !== 'Notification')
                .map((i) => {
                    return {
                        id: 'FVGFiles',
                        data: [i.fileName, i.pyCategory, 'Download'],
                        fileName: i.fileName,
                        pyCategory: i.pyCategory,
                        DownloadLink: i.DownloadLink
                    };
                });
        } else {
            files = uploadedFiles.map((i) => {
                return {
                    id: 'FVGFiles',
                    data: [i.fileName, i.pyCategory, 'Download'],
                    fileName: i.fileName,
                    pyCategory: i.pyCategory,
                    DownloadLink: i.DownloadLink
                };
            });
        }
        downloads = {
            id: 'download',
            formID: 'download',
            hasError: true,
            values: { files }
        };

        return [downloads];
    }

    if (_content?.FVGApplication) {
        summary = {
            id: 'summary',
            formID: 'summary',
            hasError: true,
            values: {
                [`summary-transactionType`]: _content?.pyStatusCustomerSat,
                [`summary-title`]: _content?.Title,
                [`summary-application-name`]: _content?.ApplicationType,
                [`summary-application-category`]: '',
                [`summary-application-number`]: _content?.ApplicationType,
                [`summary-application-businessStatus`]: _content?.BusinessStatus,
                [`summary-application-submission`]: _content?.pxCommitDateTime,
                [`summary-gbl-id`]: _content?.IDNo,
                [`summary-id`]: _content?.caseid,
                [`summary-status`]: _content?.CustomerStatus,
                [`summary-start-date`]: '',
                [`summary-expiry-date`]: '',
                [`summary-date-submission`]: formatDateTime(_content?.pxCreateDateTime),
                caseID: _content?.caseid
            }
        };

        general = {
            id: general_selected,
            formID: `appDetails-${general_selected}`,
            title: general_selected === 'generalCompany' ? 'Organisation Details' : 'Applicant Details',
            hasError: true,
            values: {
                [`${SECT_APPLICANT}-id-type`]:
                    dropdownOpts?.IDTypeFVG?.find((i: any) => i.optLabel === applicantValues.IDType)?.optID || applicantValues.IDType,
                [`${SECT_APPLICANT}-idno`]: applicantValues.IDNo,
                [`${SECT_APPLICANT}-salutaion`]: applicantValues.Salutation,
                [`${SECT_APPLICANT}-name`]: applicantValues.Name,
                [`${SECT_APPLICANT}-email`]: applicantContact.EmailAddress,
                [`${SECT_APPLICANT}-other-email`]: applicantContact.OtherEmailAddress,
                [`${SECT_APPLICANT}-mobile-no-country-code`]: applicantContact.MobileNoCountryCode || '65',
                [`${SECT_APPLICANT}-mobile-no-main`]: applicantContact.MobileNo,
                [`${SECT_APPLICANT}-other-mobile-no-main`]: applicantContact.OtherPhoneNumber,
                [`${SECT_APPLICANT}-other-mobile-no-country-code`]: applicantContact.OtherPhoneNumberCountryCode || '65',
                // [`${SECT_APPLICANT}-nationality`]: applicantValues.Nationality,

                [`${ORGANISATION_DETAILS}-organisation-uen-no`]: companyValues.UEN,
                [`${ORGANISATION_DETAILS}-organisation-name`]: companyValues.CompanyName,
                [`${ORGANISATION_DETAILS}-organisation-mobile-no-country-code`]: companyContact.MobileNoCountryCode || '65',
                [`${ORGANISATION_DETAILS}-organisation-mobile-no-main`]: companyContact.MobileNo,
                [`${ORGANISATION_DETAILS}-organisation-email`]: companyContact.EmailAddress,

                [`${SECT_ADDRESS}-postal`]: applicantAddress.PostalCode || companyAddress.PostalCode,
                [`${SECT_ADDRESS}-block-house`]: applicantAddress.BlockNumber || companyAddress.BlockNumber,
                [`${SECT_ADDRESS}-street`]: applicantAddress.StreetName || companyAddress.StreetName,
                [`${SECT_ADDRESS}-floor`]: applicantAddress.FloorNumber || companyAddress.FloorNumber,
                [`${SECT_ADDRESS}-unit`]: applicantAddress.UnitNumber || companyAddress.UnitNumber,
                [`${SECT_ADDRESS}-building`]: applicantAddress.BuildingName || companyAddress.BuildingName
            }
        };

        title = await Promise.all(
            _content?.FVGApplication?.TitleList?.map(async (videogame: any, index: number) => {
                return {
                    id: `videogames-title-${index + 1}`,
                    formID: 'appDetails-title',
                    title: 'Application Details',
                    hasError: true,
                    values: {
                        [`${TITLE_DETAILS}-case-id`]: _content?.caseid || '',
                        [`${TITLE_DETAILS}-title`]: videogame.Title || '',
                        [`${TITLE_DETAILS}-romanized-title`]: videogame.RomanizedTitle || '',
                        [`${TITLE_DETAILS}-language`]: videogame.Language || '',
                        [`${TITLE_DETAILS}-quantity`]: videogame.Quantity || '',
                        [`${TITLE_DETAILS}-format`]: videogame.Format || '',
                        [`${TITLE_DETAILS}-country-of-publication`]: videogame.Country || '',
                        [`${TITLE_DETAILS}-software-category`]: videogame.Category || '',
                        [`${TITLE_DETAILS}-declarant-remarks`]: videogame.Remarks || ''
                    }
                };
            })
        );
    }

    return newApplication ? [general, ...(title || [])] : [summary, general, ...(title || [])];
};

// eslint-disable-next-line complexity
export const formatSave = async (
    details: DetailsType,
    caseTypeID: string,
    pageInstructions: any[] = [],
    userRole?: string,
    action?: string
) => {
    if (action === 'application-delete') return payloadFVGDeleteApplication;
    const general = details.forms.find((form: FormData) => form.id === 'generalApplicant' || form.id === 'generalCompany')?.values || {};
    const videogamesDetails = details.forms.filter((form: FormData) => form.formID === 'appDetails-title');

    let pageInstructionsForDelete: any[] = [];

    await Promise.all(
        videogamesDetails.map(async (videogame: FormData, videogameIndx: number) => {
            const videogameValues = videogame?.values || {};

            // filesToUpload = [...filesToUpload, ...attachmentsAction.toUpload];
            pageInstructionsForDelete = [...pageInstructionsForDelete];
        })
    );

    return {
        caseTypeID,
        LoginType: userRole,
        content: {
            applicant: {
                IDNo: general[`${SECT_APPLICANT}-idno`] || '',
                IDType:
                    general[`${SECT_APPLICANT}-id-type`] === 'IDT' ? 'NRIC' : general[`${SECT_APPLICANT}-id-type`] === 'IDT2' ? 'FIN' : '',
                pxObjClass: 'IMDA-Data-Applicant',
                Salutation: general[`${SECT_APPLICANT}-salutaion`] || '',
                Name: general[`${SECT_APPLICANT}-name`] || '',
                // Address: [
                //     {
                //         pxObjClass: 'IMDA-Data-Address',
                //         MailingAddress: {
                //             BlockNumber: general[`${SECT_ADDRESS}-block-house`] || '',
                //             BuildingName: general[`${SECT_ADDRESS}-building`] || '',
                //             FloorNumber: general[`${SECT_ADDRESS}-floor`] || '',
                //             UnitNumber: general[`${SECT_ADDRESS}-unit`] || '',
                //             PostalCode: general[`${SECT_ADDRESS}-postal`] || '',
                //             pxObjClass: 'IMDA-Data-Address',
                //             StreetName: general[`${SECT_ADDRESS}-street`] || ''
                //         }
                //     }
                // ],
                MailingAddress: {
                    BlockNumber: general[`${SECT_ADDRESS}-block-house`] || '',
                    BuildingName: general[`${SECT_ADDRESS}-building`] || '',
                    FloorNumber: general[`${SECT_ADDRESS}-floor`] || '',
                    UnitNumber: general[`${SECT_ADDRESS}-unit`] || '',
                    PostalCode: general[`${SECT_ADDRESS}-postal`] || '',
                    pxObjClass: 'IMDA-Data-Address',
                    StreetName: general[`${SECT_ADDRESS}-street`] || ''
                },
                ContactPage: {
                    EmailAddress: general[`${SECT_APPLICANT}-email`] || '',
                    OtherEmailAddress: general[`${SECT_APPLICANT}-other-email`] || '',
                    MobileNoCountryCode: general[`${SECT_APPLICANT}-mobile-no-country-code`] || '',
                    MobileNo: general[`${SECT_APPLICANT}-mobile-no-main`] || '',
                    OtherPhoneNumberCountryCode: general[`${SECT_APPLICANT}-other-mobile-no-country-code`] || '',
                    OtherPhoneNumber: general[`${SECT_APPLICANT}-other-mobile-no-main`] || '',
                    pxObjClass: 'IMDA-Data-ContactPage'
                }
            },
            ...(userRole === 'corppass' && {
                company: {
                    CompanyName: general[`${ORGANISATION_DETAILS}-organisation-name`] || '',
                    UEN: general[`${ORGANISATION_DETAILS}-organisation-uen-no`] || '',
                    // Address: [
                    //     {
                    //         pxObjClass: 'IMDA-Data-Address',
                    //         MailingAddress: {
                    //             BlockNumber: general[`${SECT_ADDRESS}-block-house`] || '',
                    //             BuildingName: general[`${SECT_ADDRESS}-building`] || '',
                    //             FloorNumber: general[`${SECT_ADDRESS}-floor`] || '',
                    //             UnitNumber: general[`${SECT_ADDRESS}-unit`] || '',
                    //             PostalCode: general[`${SECT_ADDRESS}-postal`] || '',
                    //             pxObjClass: 'IMDA-Data-Address',
                    //             StreetName: general[`${SECT_ADDRESS}-street`] || ''
                    //         }
                    //     }
                    // ],
                    MailingAddress: {
                        BlockNumber: general[`${SECT_ADDRESS}-block-house`] || '',
                        BuildingName: general[`${SECT_ADDRESS}-building`] || '',
                        FloorNumber: general[`${SECT_ADDRESS}-floor`] || '',
                        UnitNumber: general[`${SECT_ADDRESS}-unit`] || '',
                        PostalCode: general[`${SECT_ADDRESS}-postal`] || '',
                        pxObjClass: 'IMDA-Data-Address',
                        StreetName: general[`${SECT_ADDRESS}-street`] || ''
                    },
                    ContactPage: {
                        MobileNo: general[`${ORGANISATION_DETAILS}-organisation-mobile-no-main`] || '',
                        MobileNoCountryCode: general[`${ORGANISATION_DETAILS}-organisation-mobile-no-country-code`] || '',
                        EmailAddress: general[`${ORGANISATION_DETAILS}-organisation-email`] || '',
                        pxObjClass: 'IMDA-Data-ContactPage'
                    }
                }
            }),
            IDNo: general[`${SECT_APPLICANT}-idno`] || '',
            DraftTitle: ((t) => (t.length > 1 ? t.join(', ') : t[0] || ''))(
                videogamesDetails.map((v: FormData) => v.values?.[`${TITLE_DETAILS}-title`] || '').filter(Boolean)
            ),
            FVGApplication: {
                TitleList: videogamesDetails.map((vg: FormData) => {
                    const videogame = vg?.values || {};
                    const videogamePayload = {
                        Title: videogame[`${TITLE_DETAILS}-title`] || '',
                        RomanizedTitle: videogame[`${TITLE_DETAILS}-romanized-title`] || '',
                        Language: videogame[`${TITLE_DETAILS}-language`] || '',
                        Quantity: videogame[`${TITLE_DETAILS}-quantity`] || '',
                        Format: videogame[`${TITLE_DETAILS}-format`] || '',
                        Country: videogame[`${TITLE_DETAILS}-country-of-publication`] || '',
                        Category: videogame[`${TITLE_DETAILS}-software-category`] || '',
                        Remarks: videogame[`${TITLE_DETAILS}-declarant-remarks`] || ''
                    };
                    return videogamePayload;
                })
            }
        },
        ...(pageInstructionsForDelete.length > 0 && { pageInstructions: pageInstructionsForDelete }),
        ...(pageInstructions?.length > 0 && { pageInstructions })
    };
};

const interactiveSoftwarePayload = {
    formatRetrieve,
    autoFillData,
    formatSave
};

export default interactiveSoftwarePayload;
